class Form {
  constructor() {
    if(document.querySelector('.wpcf7-form') == null) return
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$form = document.querySelector('.wpcf7-form')
    this.ui.$inputs = this.ui.$form.querySelectorAll('.field-input .wpcf7-text')
    this.ui.$labels = this.ui.$form.querySelectorAll('.field-label')
    this.ui.$select = this.ui.$form.querySelector('.field.field--select')
    this.ui.$submit = this.ui.$form.querySelector('.field-submit')
    this.lang = document.documentElement.lang
    wpcf7.init(this.ui.$form);
  }

  bindEvents() {
    for (let i = 0; i < this.ui.$inputs.length; i++) {
      this.ui.$inputs[i].addEventListener('focus', this.onFocus.bind(this))
      this.ui.$inputs[i].addEventListener('focusout', this.onFocusOut.bind(this))
    }
    
    this.ui.$submit.addEventListener('click', this.onClick.bind(this))
  }

  onFocus(e) {
    const target = e.currentTarget
    const label = target.closest('.field').querySelector('.field-label')
    label.classList.add('is-hidden')
    target.closest('.field').querySelector('.field-input').classList.add('is-focused')
  }

  onFocusOut(e) {
    const target = e.currentTarget
    const label = target.closest('.field').querySelector('.field-label')
    target.closest('.field-input').classList.remove('is-focused')

    if(target.value == "") {
      label.classList.remove('is-hidden')
    }
  }

  onClick(e) {
    const target = e.currentTarget
    
    if(!target.matches('.field-submit')) return

    setTimeout(() => {
      for (let i = 0; i < this.ui.$inputs.length; i++) {
        let label = this.ui.$inputs[i].closest('.field').querySelector('.field-label')
        label.classList.remove('is-hidden')
        this.ui.$inputs[i].closest('.field-input').classList.remove('is-focused')
      }

      if(this.lang == 'fr-FR') {
        this.ui.$select.querySelector('.field-label label').textContent = "Objet"
      } else {
        this.ui.$select.querySelector('.field-label label').textContent = "Object"
      }
    }, 600)

    return false
  }
}

export default Form
